// components/USPs.tsx

function SwissFlag({ className = "w-8 h-8" }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 100 100"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" fill="#FF0000" />
      <rect x="40" y="20" width="20" height="60" fill="#fff" />
      <rect x="20" y="40" width="60" height="20" fill="#fff" />
    </svg>
  );
}

function ShieldIcon({ className = "w-8 h-8" }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TargetIcon({ className = "w-8 h-8" }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <circle cx="12" cy="12" r="6" strokeWidth="2" />
      <circle cx="12" cy="12" r="2" strokeWidth="2" />
    </svg>
  );
}

export default function USPs() {
  const items = [
    {
      id: "SwissOrigin",
      icon: <SwissFlag className="w-10 h-10" />,
      title: "Swiss Origin – Qualité Garantie",
      text: "Entreprise suisse rigoureuse, gage de fiabilité et de précision.",
    },
    {
      id: "DesignedByExperts",
      icon: <TargetIcon className="w-10 h-10 text-gray-700" />,
      title: "Pensés par des passionnés",
      text: "Conçus par des chasseurs et tireurs pour un rangement pratique et adapté.",
    },
    {
      id: "CertifiedSecurity",
      icon: <ShieldIcon className="w-10 h-10 text-green-600" />,
      title: "Sécurité et robustesse certifiées",
      text: "Acier renforcé et serrures testées pour protéger vos armes en toute confiance.",
    },
  ];

  return (
    <section className="usps-section">
      <div className="usps">
        {items.map(({ icon, title, text, id }) => (
          <div key={id} className="usp">
            {icon}
            <h2>{title}</h2>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
